import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PiiValidateModel} from '@app/models/pii-validate.model';
import {take} from 'rxjs/operators';
import {ConfirmationService} from 'primeng/api';
import {UserSoiCampaignDonationService} from '@services/user-soi-campaign-donation.service';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {ContextService} from '@services/context.service';
import {AddressModel} from '@app/models/addresses.model';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';

@Component({
  selector: 'app-registration-page-1',
  templateUrl: './registration-page-1-contact.component.html',
  styleUrls: ['./registration-page-1-contact.component.scss'],
  imports: [
    SharedImports, AddressFormCustomComponent]
})

export class RegistrationPage1ContactComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  recurring: boolean = false;
  isSearching: boolean = false;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressMailing = {} as AddressModel;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;

  constructor(private formBuilder: FormBuilder,
              private userSoiCampaignDonationService: UserSoiCampaignDonationService, private confirmationService: ConfirmationService,
              public contextService: ContextService) {
    this.mainForm = this.formBuilder.group({
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      mobile: new FormControl(null),
      // jobTitle: new FormControl(null, [Validators.required]),
      // agency: new FormControl(null, [Validators.required]),
      // workLocation: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      zip4: new FormControl(null),
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mainForm.get('firstName').setValue(this.registrationProfile.FirstName);
    this.mainForm.get('lastName').setValue(this.registrationProfile.LastName);
    this.mainForm.get('email').setValue(this.registrationProfile.EmailAddress);
    this.mainForm.get('mobile').setValue(this.registrationProfile.MobilePhone);
    this.mainForm.get('address').setValue(this.registrationProfile.Address1);
    this.mainForm.get('address2').setValue(this.registrationProfile.Address2);
    this.mainForm.get('city').setValue(this.registrationProfile.City);
    this.mainForm.get('state').setValue(this.registrationProfile.StateProvinceID);
    this.setStateId = this.registrationProfile.StateProvinceID;
    this.mainForm.get('zipCode').setValue(this.registrationProfile.Zip);

    this.incomingAddressMailing.Zip = this.registrationProfile.Zip;
    this.incomingAddressMailing.Address1 = this.registrationProfile.Address1;
    this.incomingAddressMailing.Address2 = this.registrationProfile.Address2;
    this.incomingAddressMailing.City = this.registrationProfile.City;
    this.incomingAddressMailing.StateProvinceID = this.registrationProfile.StateProvinceID;
    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.registrationProfile.FirstName = this.mainForm.get('firstName').value;
      this.registrationProfile.LastName = this.mainForm.get('lastName').value;
      this.registrationProfile.EmailAddress = this.mainForm.get('email').value;
      this.registrationProfile.MobilePhone = this.mainForm.get('mobile').value;
      this.registrationProfile.Address1 = this.mainForm.get('address').value;
      this.registrationProfile.Address2 = this.mainForm.get('address2').value;
      this.registrationProfile.City = this.mainForm.get('city').value;
      this.registrationProfile.StateProvinceID = this.mainForm.get('state').value;
      this.registrationProfile.Zip = this.mainForm.get('zipCode').value;
      this.registrationProfile.OrganizationID = this.organizationDetails.OrganizationId;
      if (this.registrationProfile.MobilePhone) {
        this.registrationProfile.MobilePhone = this.registrationProfile.MobilePhone.replace(/\D/g, '');
      }
      this.updateData.emit(this.registrationProfile);
    });
  }


  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      this.mainForm.markAsDirty();
      this.registrationProfile.CountryID = 1;
      this.registrationProfile.Address1 = addressChanges.Address1;
      this.registrationProfile.Address2 = addressChanges.Address2;
      this.registrationProfile.City = addressChanges.City;
      this.registrationProfile.StateProvinceID = addressChanges.StateProvinceID;
      this.registrationProfile.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);
    }
  }

  validatePii(key: string, value: string): void {
    this.isSearching = true;
    const piiData: PiiValidateModel = {
      SSN: null,
      SIN: null,
      PrimaryEmailAddress: null,
      PersonID: null,
      MatchType: key
    };
    piiData[key] = value;
    this.userSoiCampaignDonationService.validatePii(piiData)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.isSearching = false;
          const baseURI = document.baseURI;
          if (res.MatchType) {
            const ref = this.confirmationService.confirm({
              header: 'Duplicate User(s) Found',
              icon: 'fas fa-exclamation-triangle',
              message: `This email is already in use. Please <a href="${baseURI}">log into your account</a> to update your profile.`,
              acceptVisible: false,
              rejectLabel: 'Cancel'
            });
            this.mainForm.get('email').setValue(null);
          }
        }
      });
  }

  goToNextPage() {
    const tempAddress = {} as AddressModel;
    tempAddress.Address1 = this.registrationProfile.Address1;
    tempAddress.Address2 = this.registrationProfile.Address2;
    tempAddress.City = this.registrationProfile.City;
    tempAddress.StateProvinceID = this.registrationProfile.StateProvinceID;
    tempAddress.Zip = this.registrationProfile.Zip;
    this.incomingAddressMailing = tempAddress;
    this.next.emit();
  }

}
